module.exports = __webpack_public_path__ + "media/images/keeper-test-drive-icon-26efbc64.png";